<template>
  <div class="dashboard-page">
    <h1 class="page-title">Dashboard</h1>
    <div class="sidesWrapper">
      <div style="width: 100%">
        <b-tabs nav-class="bg-transparent">
          <b-tab title="Pengendalian" active>
            <div class="d-flex gap-2">
              <div>
                <select v-model="filter_tahun" id="filter_tahun1" class="form-select">
                  <option v-for="d in optionTahun" :value="d">{{ d }}</option>
                </select>
              </div>
              <div>
                <select v-model="filter_bulan" id="filter_bulan1" class="form-select" aria-label="Filter bulan">
                  <option value="all">Semua Bulan</option>
                  <option v-for="(bulan, index) in optionBulan" :key="index" :value="String(index + 1)">
                    {{ bulan }}
                  </option>
                </select>
              </div>
            </div>

            <MainChart :jumlah_laporan="jumlah_laporan" :jumlah_laporan_status="jumlah_laporan_status" />

            <div class="row mt-4 g-3">
              <div class="col-xl-6">
                <StatusPenyampaianChart
                  :jumlah_laporan_status_penyampaian="jumlah_laporan_status_penyampaian"
                  :filter-tahun="filter_tahun"
                />
              </div>
              <div class="col-xl-6">
                <HasilPenilaianChart :filter-tahun="filter_tahun" :filter-bulan="filter_bulan" />
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <MapPengendalian :tahun="filter_tahun" :bulan="filter_bulan" />
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <JumlahPenerimaPenghargaanProvinsi :filter-tahun="filter_tahun" :filter-bulan="filter_bulan" />
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <JumlahPenerimaPenghargaanTimeseries :filter-tahun="filter_tahun" :filter-bulan="filter_bulan" />
              </div>
            </div>
          </b-tab>
          <b-tab title="Pelaksanaan" lazy>
            <DashboardPelaksanaan />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import HasilPenilaianChart from './HasilPenilaianChart.vue'
import StatusPenyampaianChart from './StatusPenyampaianChart.vue'
import JumlahPenerimaPenghargaanTimeseries from './JumlahPenerimaPenghargaanTimeseries.vue'
import MapPengendalian from './MapPengendalian.vue'
import RealisasiChart from './RealisasiChart.vue'
import MainChart from './MainChart.vue'
import axios from 'axios'
import JumlahPenerimaPenghargaanProvinsi from './JumlahPenerimaPenghargaanProvinsi.vue'
import DashboardPelaksanaan from '../Pelaksanaan/DashboardPelaksanaan.vue'

export default {
  components: {
    MainChart,
    StatusPenyampaianChart,
    JumlahPenerimaPenghargaanTimeseries,
    HasilPenilaianChart,
    MapPengendalian,
    RealisasiChart,
    JumlahPenerimaPenghargaanProvinsi,
    DashboardPelaksanaan,
  },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      filter_tahun: new Date().getFullYear(),
      filter_bulan: 'all',
      jumlah_laporan: {
        laporan_tahunan: 0,
        laporan_berusaha: 0,
        laporan_nonberusaha: 0,
      },
      jumlah_laporan_status: {
        laporan_selesai: 0,
        laporan_belum_verifikasi: 0,
        laporan_sudah_terima: 0,
        laporan_dalam_proses: 0,
        laporan_perlu_diperbaiki: 0,
      },
      jumlah_laporan_status_penyampaian: {
        label: [],
        series: [],
      },
    }
  },
  methods: {
    async getJumlahLaporan() {
      const res = await axios.get(
        `${this.baseapiPengendalian}api/dashboard/getJumlahLaporan?tahun=${this.filter_tahun}&bulan=${this.filter_bulan}`,
        this.getApiOption(),
      )
      if (res.data?.data) {
        this.jumlah_laporan = res.data.data
      }
    },

    async getJumlahLaporanStatus() {
      const res = await axios.get(
        `${this.baseapiPengendalian}api/dashboard/getJumlahLaporanStatus?tahun=${this.filter_tahun}&bulan=${this.filter_bulan}`,
        this.getApiOption(),
      )
      if (res.data?.data) {
        this.jumlah_laporan_status = res.data.data
      }
    },

    async getJumlahLaporanStatusPenyampaian() {
      const res = await axios.get(
        `${this.baseapiPengendalian}api/dashboard/getJumlahLaporanStatusPenyampaian?tahun=${this.filter_tahun}&bulan=${this.filter_bulan}`,
        this.getApiOption(),
      )
      if (res.data?.data) {
        this.jumlah_laporan_status_penyampaian = res.data.data
      }
    },

    refreshDashboard() {
      this.getJumlahLaporan()
      this.getJumlahLaporanStatus()
      this.getJumlahLaporanStatusPenyampaian()
    },

    getApiOption(option = {}) {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
        ...option,
      }
    },
  },
  computed: {
    optionTahun() {
      const currentYear = new Date().getFullYear()
      return Array.from({ length: 10 }, (_, i) => currentYear - i)
    },
    optionBulan() {
      return ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
    },
  },
  watch: {
    filter_tahun() {
      this.refreshDashboard()
    },
    filter_bulan() {
      this.refreshDashboard()
    },
  },
  created() {
    this.refreshDashboard()
  },
}
</script>
